export default "__VITE_ASSET__B2_2CeXa__"